import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "../Flex";
import { Skeleton } from "../Skeleton";
import { Container } from "./styles";
export function ProgressiveDiscountSkeleton() {
    return (_jsxs(Container, { direction: "column", gap: "0", width: "118.4px", children: [_jsx(Skeleton, { width: "100%", height: "34px" }), _jsx(Flex, { padding: "4px 4px 0", justifyContent: "center", children: _jsx(Skeleton, { width: "56px", height: "20px" }) })] }));
}
//# sourceMappingURL=Skeleton.js.map